'use client';

import { GTMEventKey, CustomEventName, sendGTM } from '@fe-cnyes/fe-common-gtm';
import { useIsInteractingObserver } from '@fe-common-utils/libs/hooks/useIsInteractingObserver';
import { useCallback, useRef } from 'react';

const OBSERVER_OPTIONS = {
  root: null,
  rootMargin: '0px',
  threshold: 1
};

type InteractingObserverGtmProps = {
  gtmEvent?: {
    [GTMEventKey.EVENT_NAME]: CustomEventName;
    [GTMEventKey.SECTION]: string;
  };
};

/**
 * 當滑動到元件位置時，發送GTM事件 參考自fe-lobby-forex-v2
 * @returns
 */
const InteractingObserverGtm = ({ gtmEvent }: InteractingObserverGtmProps) => {
  const countEnter = useRef(0);
  const onEnter = useCallback(() => {
    if (!countEnter?.current) {
      countEnter.current = 1;
      if (gtmEvent) sendGTM(gtmEvent);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const reference = useIsInteractingObserver(onEnter, OBSERVER_OPTIONS);

  return <div ref={reference} />;
};

export default InteractingObserverGtm;
